<app-modal-container [title]="title"
                     [actionButtonName]="'Leave Page'"
                     (action)="confirmLeavePage()">
  <div class="pb-2">
    <div class="mb-3">Are you sure you want to leave this page?</div>
    <div>Changes you have made will not be saved</div>
  </div>
</app-modal-container>
